import React from 'react';
import { ArrowUpRightIcon, MapPinIcon, ClockIcon } from 'lucide-react';
import { EVENTS } from '../../data/site';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
export function Events() {
  return <section id="events" className="relative mx-auto w-full max-w-7xl px-5 py-20 sm:px-8 sm:py-28" data-id="element-154" data-mp="2i9v05108w2i2">
      <SectionHeading eyebrow="ON THE CALENDAR" title={<>
            Upcoming <span className="text-gradient" data-id="element-156" data-mp="39zzeahxevtau">shows</span>
          </>} description="Beach bars, rooftops and warehouses across the Gulf Coast — with headliners we grew up listening to." data-id="element-155" data-mp="2dccm4w7dex37" />

      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-157" data-mp="316cnz7bz3i91">
        {EVENTS.map((event, i) => {
        // asset diet: card-sized compressed variant, never the raw flyer (Aug 29)
        const cover = event.cover.replace('/upload/', '/upload/f_auto,q_auto,w_640/');
        return <Reveal key={event.title} delay={i * 0.08} className="h-full" data-id="element-158" data-mp="3ovylzrglzrfg" data-mpi={i}>
            <article className="glass group relative flex h-full flex-col overflow-hidden rounded-2xl transition-[transform,border-color,box-shadow] duration-300 ease-expo hover:-translate-y-1.5 hover:border-violet/50 hover:shadow-neon" data-id="element-159" data-mp="3mr5tkeb4wmuf">
              {/* aspect-video matches the flyers' native 16:9 — no side-cropping of their headers */}
              <div className="relative aspect-video overflow-hidden" data-id="element-160" data-mp="3404ln0s1dgyq">
                <img src={cover} alt={`Event artwork for ${event.title}`} className="h-full w-full object-cover transition-transform duration-500 ease-expo group-hover:scale-[1.06]" loading={i === 0 ? 'eager' : 'lazy'} data-id="element-161" data-mp="33ythgzuoi773" />
                <div aria-hidden="true" className="absolute inset-0" style={{
                background: 'linear-gradient(180deg, rgba(4,3,12,0) 40%, rgba(4,3,12,0.85) 100%)'
              }} data-id="element-162" data-mp="2z34fyqz3mg85" />
                {i === 0 ? <span className="absolute left-4 top-4 rounded-full bg-cyan px-3 py-1.5 font-tech text-[0.6rem] font-bold tracking-[0.24em] text-void" data-id="element-163" data-mp="217s9v4wtabz7">
                    NEXT EVENT
                  </span> : null}
                <div className="absolute bottom-4 left-4 flex items-center gap-3" data-id="element-164" data-mp="1s7vqnit6y5bj">
                  <span className="font-script text-base tracking-wide text-cyan" data-id="element-165" data-mp="2oxcx3zzzzvea">
                    {event.date.toUpperCase()}
                  </span>
                  <span className="inline-flex items-center gap-1 font-tech text-xs tracking-[0.14em] text-white/60" data-id="element-166" data-mp="2kxvowyt6sk5f">
                    <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="2b5yc5nmj5k4l" />
                    {event.time}
                  </span>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-6" data-id="element-168" data-mp="38n6v4vtb36qy">
                <h3 className="font-display text-sm leading-snug tracking-[0.06em] text-white sm:text-[0.95rem]" data-id="element-169" data-mp="33tcbtthm4tse">
                  {event.title}
                </h3>
                <p className="mt-3 flex items-start gap-2 text-sm text-white/55" data-id="element-170" data-mp="3g4d2t7rarnvg">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-magenta" aria-hidden="true" data-id="element-171" data-mp="3g6g1eg6impbs" />
                  <span data-id="element-172" data-mp="3l62fssy2ybm6">
                    {event.venue}
                    <br data-id="element-173" data-mp="3p62xcmgh72xg" />
                    {event.city}
                  </span>
                </p>
                <p className="mt-3 font-tech text-[0.7rem] tracking-[0.16em] text-white/35" data-id="element-174" data-mp="3u3uxu4v6rxd9">
                  {event.presenter.toUpperCase()}
                </p>
                <a href={event.tickets} target="_blank" rel="noopener noreferrer" className="mt-6 flex items-center justify-between gap-2 rounded-xl border border-violet/40 bg-violet/10 px-5 py-3.5 font-tech text-xs font-semibold tracking-[0.18em] text-white transition-[background-color,border-color,transform] duration-200 ease-expo hover:-translate-y-0.5 hover:border-violet hover:bg-violet" style={{
                marginTop: 'auto'
              }} data-id="element-175" data-mp="7o9x37jqw99r">
                  <span data-id="element-176" data-mp="3zqyat8jyk0q">GET TICKETS</span>
                  <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-177" data-mp="hrnlqjza05qs" />
                </a>
              </div>
            </article>
          </Reveal>;
      })}
      </div>
    </section>;
}